import React from 'react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { MOCKUP_URL } from '../../data/images';
const assurances = ['Instant Digital Access', 'Print-Ready Resources', 'One-Time Payment'];
export function HeroSection() {
  return <section aria-labelledby="hero-heading" className="bg-brand-paper px-5 pb-16 pt-10 lg:px-8 lg:pb-20 lg:pt-14" data-id="element-102" data-mp="16l6vnugat6tl">
      <div className="mx-auto max-w-4xl text-center" data-id="element-103" data-mp="1zbypwmdszlea">
        <p className="mx-auto max-w-xl font-body text-[11px] font-bold uppercase leading-relaxed tracking-[0.18em] text-brand-plum" data-id="element-104" data-mp="1zbp0p10l1i9n">
          For Makeup Instructors, Educators & Professional MUAs Who Teach
        </p>

        <h1 id="hero-heading" className="mt-5 font-display text-[2.6rem] font-bold leading-[1.02] tracking-[-0.015em] text-brand-charcoal sm:text-[3.4rem] lg:text-[4.25rem]" data-id="element-105" data-mp="1qdmyii544jks">
          Stop Building Every Makeup Class <Accent data-id="element-106" data-mp="9wr3dqlt0jcs">From Scratch.</Accent>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-[16px] font-semibold leading-relaxed text-brand-charcoal sm:text-[17px]" data-id="element-107" data-mp="9zdchuocf6x4">
          Get a complete professional system to plan, teach, practice, assess and manage your makeup
          education — all in one place.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-108" data-mp="2zf4y4a6glp8i">
          Makeup Instructor Ready gives you the frameworks, teaching resources, student practice tools,
          assessment systems and classroom materials you need to deliver more structured, professional
          makeup education — without creating everything yourself.
        </p>
      </div>

      <figure className="mx-auto mt-10 w-full max-w-[1040px]" data-id="element-109" data-mp="2gr00lkgeb0i5">
        <img src={MOCKUP_URL} alt="Makeup Instructor Ready — the six core volumes in front, the five extra bonuses below, shown with a tablet and laptop" width={1536} height={1024} loading="eager" decoding="async" className="block w-full rounded-[18px] object-contain shadow-[0_40px_80px_-40px_rgba(59,27,87,0.45)] sm:rounded-[24px]" data-id="element-110" data-mp="2kpz3z0mhap7h" />
      </figure>

      <p className="mx-auto mt-8 w-fit rounded-full border border-brand-plum/25 bg-white px-5 py-2 font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-plum" data-id="element-111" data-mp="chkid3zj75gd">
        6 Core Volumes + 5 Extra Bonuses
      </p>

      <ul className="mt-5 flex flex-wrap justify-center gap-x-3 gap-y-1 font-body text-[13px] text-brand-charcoal/65" role="list" data-id="element-112" data-mp="3gm9o8e5e9rg">
        {assurances.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-113" data-mp="w7w4ua99fqqe" data-mpi={index}>
            {index > 0 && <span aria-hidden="true" className="text-brand-berry" data-id="element-114" data-mp="r6qc4cflo3gv">•</span>}
            {item}
          </li>)}
      </ul>

      <div className="mt-8 text-center" data-id="element-115" data-mp="mb1am3k0schx">
        <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-plum" data-id="element-116" data-mp="3bys7qzabrtl1">Today</p>
        <p className="mt-1 font-body text-[3rem] font-bold leading-none tracking-[-0.01em] text-brand-charcoal" data-id="element-117" data-mp="36yw9zhs80ydx">
          US$27
        </p>
      </div>

      <CtaBlock label="Get Makeup Instructor Ready — $27" note="One-Time Payment • Instant Access • No Subscription" className="mt-6" data-id="element-118" data-mp="2wte9bs7xbgf7" />
    </section>;
}